import { APP_TYPE, WEBVIEW_TYPES } from '@/lib/consts.js'
import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('ios-tablet-identity')

const IOS_TABLET_IDENTITY_KEY = 'identity.local'

const isIosTablet = (store) => {
  return store.state.app.webView === WEBVIEW_TYPES.IOS
    && store.state.app.appType === APP_TYPE.TABLET
}

export const saveIosTabletIdentity = (store) => {
  if (isIosTablet(store)) {
    logger.debug(`saving identity into local storage`, store.state.identity)
    localStorage.setItem(IOS_TABLET_IDENTITY_KEY, JSON.stringify(store.state.identity))
  }
}

export const loadIosTabletIdentity = (store) => {
  if (isIosTablet(store)) {
    logger.debug(`loading identity from local storage`)
    const localIdentity = localStorage.getItem(IOS_TABLET_IDENTITY_KEY)
    try {
      return JSON.parse(localIdentity)
    } catch {
    }
  }
}

export const clearIosTabletIdentity = () => {
  localStorage.removeItem(IOS_TABLET_IDENTITY_KEY)
}
